import { useState, useEffect, useContext, useCallback } from "react";
import { Redirect } from "react-router-dom";
import { Box, Grid, Typography } from "@mui/material";

import Link from "../atoms/mui/Link";

import { AnimatedLogo } from "@aclymatepackages/atoms";

import SignInForm from "./SignInForm";

import AccountAccessLayout from "../layouts/AccountAccessLayout";

import { handleLoggedInUser } from "../../helpers/components/accountAccess";
import { AccountAccessContext } from "../../helpers/contexts/accountAccess";
import { useAuth } from "../../helpers/firebase";
import { analyticsPage } from "../../helpers/analytics";

const SignInBlock = () => {
  const [loggedInUser, loggedInUserLoading] = useAuth();
  const { setAccountAccessError } = useContext(AccountAccessContext);

  const [userEmail, setUserEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loginLoading, setLoginLoading] = useState(false);
  const [redirect, setRedirect] = useState(false);

  const onLogin = useCallback(
    (user) =>
      handleLoggedInUser({
        user,
        setRedirect,
        setLoginLoading,
        setAccountAccessError
      }),
    [setAccountAccessError]
  );

  useEffect(() => {
    if (!loggedInUserLoading && loggedInUser?.uid && !redirect && !loginLoading) {
      onLogin(loggedInUser);
    }
  }, [loggedInUser, redirect, loginLoading, loggedInUserLoading, onLogin]);

  const renderData = () => {
    if (loggedInUserLoading) {
      return (
        <Box display="flex" alignItems="center" justifyContent="center">
          <AnimatedLogo />
        </Box>
      );
    }

    if (redirect) {
      return <Redirect to={redirect} />;
    }

    return (
      <SignInForm
        userEmail={userEmail}
        setUserEmail={setUserEmail}
        password={password}
        setPassword={setPassword}
        onLogin={onLogin}
        setAccountAccessError={setAccountAccessError}
        loginLoading={loginLoading}
        setLoginLoading={setLoginLoading}
        setRedirect={setRedirect}
        cta={
          <Grid
            item
            container
            direction="column"
            spacing={2}
            alignItems="center"
          >
            <Grid item>
              <Typography variant="body1" display="inline">
                First time here?
              </Typography>
            </Grid>
            <Grid item>
              <Link href="/account-creation/company">
                <Typography variant="body2">
                  Create a company account
                </Typography>
              </Link>
            </Grid>
          </Grid>
        }
      />
    );
  };

  return <>{renderData()}</>;
};

const Login = () => {
  useEffect(() => {
    analyticsPage("login");
  }, []);

  return (
    <AccountAccessLayout
      formTitle="Welcome back"
      formSubtitle="Log back in to your account to keep saving the world."
      layoutType="login"
    >
      <SignInBlock />
    </AccountAccessLayout>
  );
};
export default Login;
